import DEFAULT_PROPERTIES from './default';
import { LOGIN_METHOD_OKTA } from './constants';

const AIG_PROPERTIES = {
    ...DEFAULT_PROPERTIES,
    appName: 'AIG',
    shouldShowSignUp: false,
    clientId: '690399976fb38d8a5d83510b',
    clientSecret:
        '02FAG11uUar6lGq2836mdSvtS3adiSTEW8--5RFYmRWwqDta-ToORHV3a57Dox4aBm',
    loginMethods: [LOGIN_METHOD_OKTA],
    colors: {
        ...DEFAULT_PROPERTIES.colors,
        primary: '#0067B9',
        primaryDark: '#004B87',
        primaryForeground: '#FFFFFF',
        secondary: '#E6EFF6',
        secondaryDark: '#B3CFE2',
        accent: '#009FDA',
        accentDark: '#005A8B',
        loginFooter: '#0067B9',
        impactTileColor: '#E6EFF6',
    },
};

export default AIG_PROPERTIES;
